import * as React from 'react';
import { SVGProps } from 'react';

const IconExpandSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4H7.048V2H14v6.952h-2V4zm-8 8V7.048H2V14h6.952v-2H4z"
    />
  </svg>
);
export default IconExpandSizeS;
